/* eslint-disable class-methods-use-this */
import { Button, Image } from 'components/ui';
import { colors } from 'style/config';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import Venmo from 'utils/Venmo';

const venmoButtonStyle = {
    borderWidth: 0,
    backgroundColor: colors.venmoBlue
};

const venmoContainerSpanStyle = {
    display: 'none'
};

const venmoContainerSpan = (
    <span
        id='venmo-container'
        css={venmoContainerSpanStyle}
    />
);

class VenmoExpressButton extends BaseClass {
    constructor(props) {
        super(props);

        this.state = { isDisabled: false };
    }

    componentDidMount() {
        Venmo.prepareVenmoCheckout();
    }

    checkoutWithVenmo = () => {
        Venmo.triggerExpressCheckout({ isBopis: this.props.isBopis });
    };

    render() {
        const { isDisabled } = this.state;

        return (
            <Button
                variant='secondary'
                onClick={this.checkoutWithVenmo}
                disabled={isDisabled}
                data-at={Sephora.debug.dataAt('basket_venmo_btn')}
                css={venmoButtonStyle}
                {...this.props}
            >
                <Image
                    disableLazyLoad={true}
                    alt='Venmo'
                    src='/img/ufe/payments/no-border/venmo.svg'
                    verticalAlign='middle'
                />
                {venmoContainerSpan}
            </Button>
        );
    }
}

export default wrapComponent(VenmoExpressButton, 'VenmoExpressButton', true);
